// Toast notification queue.
//
// Class pattern per Svelte's recommendation — preferred over module-level
// $state + getter pairs for cross-component reactive singletons. Aligns
// with the platformLimits / identity / requestProgress pattern.

type Toast = { id: string; kind: 'success' | 'error'; message: string };

class ToastQueue {
  // Array mutates are deeply reactive — keep $state (not $state.raw) so
  // push/filter trigger updates in subscribers without reassigning the
  // whole array on every change.
  list = $state<Toast[]>([]);

  push(kind: 'success' | 'error', message: string): void {
    const id = crypto.randomUUID();
    this.list.push({ id, kind, message });
    setTimeout(() => {
      this.list = this.list.filter((t) => t.id !== id);
    }, 3000);
  }
}

export const toasts = new ToastQueue();
